<template>
  <div class="player">
    <div class="video-block" v-if="!isPlayVideo" @click="handleClickItemsVideo">
      <img :src="poster" class="video-block" alt="">
      <img src="@/assets/images/course/icon-play-course.png" class="icon-play" alt="">
    </div>
    <video id="player" v-else :poster="poster" playsinline webkit-playsinline>
    </video>

    <div class="tips" v-if="boolNextTip" :class="isRotateFullScreen ? 'fullScreen' : ''">即将播放{{ nextVideoTitle }}</div>
    <form action="javascript:;" class="input-danmu">
      <input type="text" readonly @click="danmuDialog = true" placeholder="发送弹幕" class="danmu-txt">
      <!-- <input type="text" v-model="sendDanmuVal" @keydown.enter="handleSendDanmu" enterkeyhint="send" placeholder="发送弹幕" class="danmu-txt"> -->
      <img src="@/assets/images/course/video_icon_open@2x.png" v-if="isDanmu" @click="handleClickDanmu" class="danmu-icon"
        alt="">
      <img src="@/assets/images/course/video_icon_close@2x.png" v-else @click="handleClickDanmu" class="danmu-icon"
        alt="">
    </form>
    <div class="dialog-div" v-show="danmuDialog">
      <div class="dialog-bg" @click="danmuDialog = false"></div>
      <div class="wrapper" @click.stop>
        <div class="div-confirm-txt">
          <input type="text" v-model="sendDanmuVal" readonly class="txt" @click="danmuDialog = true"
                 placeholder="请从下方选择弹幕发送">
          <!-- <div class="txt">{{sendDanmuVal ? sendDanmuVal : '请从下方选择弹幕发送'}}</div> -->
          <div class="send-btn" @click="handleSendDanmu">发送</div>
        </div>
        <div class="danmu-div">
          <div class="danmu-title">弹幕文案</div>
          <div class="danmu-list">
            <div class="danmu-item" v-for="(item, index) in barrages"
                 :class="sendDanmuVal === item.wording ? 'cur' : ''"
                 :key="index" @click="handleClickItems(item.wording)">{{ item && item.wording }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="vertical-progress" :class="isRotateFullScreen ? 'isFull' : ''">
      <van-slider v-model="slider" vertical button-size="14" @change="handleChange"/>
    </div>
    <div
      class="vjs-knowledge-points vjs-menu-button vjs-menu-button-popup vjs-control vjs-button"
      :class="isRotateFullScreen ? 'isFull' : ''"
      @click="showKnowledgePoints"
    >知识点
    </div>
    <div class="knowledge-points-list" v-if="isShowKnowledgePoints">
      <div class="header">
        <div class="title">课程知识点</div>
        <div v-if="curVideoPlayer.dotList && curVideoPlayer.dotList.length" class="header-right">
          (<i>{{ isCurDotIndex }}</i>/{{ curVideoPlayer && curVideoPlayer.dotList.length }}个知识点)
        </div>
      </div>
      <div class="cont">
        <div class="dot-list-fullscreen"
             @touchstart.stop="handleTouchStart"
             @touchend.stop="handleTouchEnd"
             @scroll="handleScroll"
             @touchmove.stop
        >
          <div
            v-for="(item, index) in curVideoPlayer.dotList"
            :key="index"
            class="dot-item-fullscreen"
            v-track="{ functionName: `${item.knowledge}` }"
            :class="item.isCurrent ? 'cur':''"
            @click.stop="changeDotTime(item)"
          >
            <div class="dot-item-cont">
              <div class="dot-icon">
                <img src="../../../assets/images/course/dot-icon.png" alt="" v-if="!item.isCurrent">
                <img src="../../../assets/images/course/dot-icon-active.png" alt="" v-else>
              </div>
              <div class="dot-title">
                <span class="name">{{ item && item.knowledge }}</span>
              </div>
            </div>
            <div class="dot-line"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import TCPlayer from 'tcplayer.js'
// import 'tcplayer.js/dist/tcplayer.min.css'
import TcPlayerBarragePlugin from 'tcplayer-barrage-plugin'
import {handleTraceVideo, handleTraceVideoAsync} from '@/utils/trace.js'
// import { traceVideoDuration } from '@/api/trace.js'
import {getBarrage, sendBarrage, barrageList} from '@/api/api'
// import { hadnleUpdateVideo } from './common'
import {iconBarrageOn, iconBarrageOff, iconForward, iconBack} from './svg.js'
import {stopScroll, canScroll} from '@/utils/util'
import {getUrlParms} from '../../../utils/util'
import Vue from 'vue'
import {ACCESS_TOKEN} from '../../../store/mutation-types'

export default {
  name: 'VideoPlayer',
  components: {},
  props: {
    // 视频源
    playerVideo: {
      type: Object,
      required: true
    },
    // 是否显示水印
    isShowWaterMark: {
      type: Boolean,
      default: false
    },
    // 课程列表
    videoList: {
      type: Array,
      required: true
    }
  },
  watch: {
    playerVideo(newVal, oldVal) {
      this.handleChangeVideo(newVal, oldVal)
    },
  },
  data() {
    return {
      playerNextBool: false, // 当前还有没有下一个视频播放
      playDurationArr: [],
      playDuration: 0,
      playDurationTrace: 0,
      curVideoPlayer: {},
      // 是否展示播放下一集
      boolNextTip: false,
      nextVideoTitle: '',
      isRotateFullScreen: false,
      sendDanmuVal: '', // 弹幕内容
      slider: 0,
      isDanmu: true,
      poster: '',
      danmuDialog: false,
      barrages: [],
      isPlayVideo: false,
      isShowKnowledgePoints: false,
      campId: '',
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
    isCurDotIndex() {
      return this.$parent.$parent.isCurDotIndex
    }
  },
  mounted() {
    this.curVideoPlayer = this.playerVideo
    this.poster = this.curVideoPlayer.poster
    this.handleInitPlayer()
    this.handleBarrageList()
    let entrance = (this.$route.query.entrance) ? this.$route.query.entrance : window.sessionStorage.getItem('entrance')
    window.sessionStorage.setItem('entrance', entrance)
    const campId = getUrlParms('businessId') || ''
    const channel = (entrance === '1' || entrance === '2' || entrance === '3') ? entrance : getUrlParms('channel') || ''
    setTimeout(() => {
      sessionStorage.setItem('video-track-cache', JSON.stringify({
        entrance,
        campId,
        channel,
      }))
    }, 400)
    window.addEventListener('unload', (e) => this.unloadHandler(e))
  },
  beforeDestroy() {
    this.handleVideoTrace(this.curVideoPlayer)
    if (this.isPlayVideo) {
      this.acPlayerToolInit.dispose()
    }
    localStorage.removeItem('playbackRate')
    localStorage.removeItem('curPlayVideoId')
    canScroll()
    setTimeout(() => {
      sessionStorage.removeItem('video-track-cache')
    }, 300)
  },
  destroyed() {
    window.removeEventListener('unload', (e) => this.unloadHandler(e))
  },
  methods: {
    // 手指按下时认为用户开始滚动知识点列表
    handleTouchStart() {
      this.$parent.$parent.handleTouchStart()
    },

    // 手指抬起后一小段时间内仍不允许置顶，防止滑动未结束
    handleTouchEnd() {
      this.$parent.$parent.handleTouchEnd()
    },
    handleScroll() {
      this.$parent.$parent.handleScroll()
    },

    changeDotTime(item) {
      this.$parent.$parent.changeDotTime(item)
    },
    showKnowledgePoints() {
      this.isShowKnowledgePoints = !this.isShowKnowledgePoints
    },
    // 点击播放视频
    handleClickItemsVideo() {
      this.isPlayVideo = true
      setTimeout(() => {
        this.handleInitPlayer()
        this.player.play()
      })
    },

    // 获取弹幕wordding列表
    handleBarrageList() {
      barrageList().then(res => {
        this.barrages = res.data
      })
    },

    // 设置输入
    handleClickItems(txt) {
      this.sendDanmuVal = txt
    },

    // 页面关闭，关闭包括了刷新，自动调用埋点数据
    async unloadHandler(e) {
      await this.handleVideoTraceSync(this.curVideoPlayer)
    },

    // 点击是否展示弹幕
    handleClickDanmu() {
      let barrageScreenDom = document.getElementById('vjs-barrage-screen')
      let barrageSwitcher = document.getElementsByClassName('vjs-barrage-switcher')[0]
      let visibility = barrageScreenDom.style.visibility
      if (visibility === 'hidden') {
        barrageScreenDom.style.visibility = 'visible'
        this.isDanmu = true
        barrageSwitcher.innerHTML = iconBarrageOn
      } else {
        barrageScreenDom.style.visibility = 'hidden'
        this.isDanmu = false
        barrageSwitcher.innerHTML = iconBarrageOff
      }
    },

    // 发送弹幕
    handleSendDanmu() {
      this.danmuDialog = false
      let params = {
        'courseId': this.$route.query.courseId,
        'courseSectionId': this.curVideoPlayer.id,
        'barrageText': this.sendDanmuVal,
        'iepUserId': this.userInfo.id,
        'barrageTime': Math.round(this.currentTime)
      }
      sendBarrage(params).then(res => {
        this.$toast(res.data.msg)
        if (!res.data.success) {
          setTimeout(() => {
            this.sendDanmuVal = ''
          })
          return
        }
        // this.barragePlugin.send({ // 发送弹幕
        //   mode: 1,
        //   text: this.sendDanmuVal,
        //   color: '#000000',
        //   size: 16,
        //   stime: Math.round(this.currentTime) * 1000
        // })
        this.barragePlugin.load([
          { // 发送弹幕
            mode: 1,
            text: this.sendDanmuVal,
            color: '#ffffff',
            size: 16,
            stime: Math.round(this.currentTime) * 1000
          }
        ])
        setTimeout(() => {
          this.sendDanmuVal = ''
        })
      })
    },

    // 初始化弹幕
    async handleGetBarrage() {
      let danmuDom = document.getElementById('vjs-barrage-screen')
      let danmuDom2 = document.getElementsByClassName('vjs-barrage-switcher')[0]
      if (danmuDom) {
        danmuDom.remove()
        danmuDom2.remove()
      }
      let barrageData = await getBarrage({
        courseId: this.$route.query.courseId,
        courseSectionId: this.curVideoPlayer.id
      })
      let barrageDataL = barrageData.data.map(res => {
        let items = {
          mode: '1',
          stime: res.barrageTime * 1000,
          text: res.barrageText,
          size: 16,
          color: '#FFFFFF'
        }
        return items
      })
      this.barragePlugin = new TcPlayerBarragePlugin(this.player, {})
      this.barragePlugin.init()
      this.barragePlugin.load(barrageDataL)
      this.barragePlugin.start()
    },

    handleChange(value) {
      // 横屏进度条控制
      let setCurTime = this.curVideoDuration / 100 * value
      this.player.currentTime(setCurTime)
    },

    backward15Seconds() {
      if (this.player) {
        const currentTime = this.player.currentTime()
        const targetTime = Math.max(0, currentTime - 15)
        this.player.currentTime(targetTime)
      }
    },
    forward15Seconds() {
      if (this.player) {
        const currentTime = this.player.currentTime()
        const duration = this.player.duration()
        if (currentTime + 15 >= duration) return
        const targetTime = Math.min(duration, currentTime + 15)
        this.player.currentTime(targetTime)
      }
    },
    // 初始化视频
    handleInitPlayer() {
      let initPlayCon = this.curVideoPlayer.videoMaterial
      if (!this.isPlayVideo) return
      // let player = TCPlayer('player', { // player-container-id 为播放器容器 ID，必须与 html 中一致
      //   fileID: initPlayCon.fileId, // 请传入需要播放的视频 fileID（必须）
      //   appID: initPlayCon.appId, // 请传入点播账号的 appID（必须）
      //   // 私有加密播放需填写 psign， psign 即播放器签名，签名介绍和生成方式参见链接：https://cloud.tencent.com/document/product/266/42436
      //   psign: initPlayCon.psign,
      //   fakeFullscreen: true
      //   // licenseUrl: 'https://license.vod2.myqcloud.com/license/v2/1255472182_1/v_cube.license',
      //   // licenseUrl: 'https://license-url',
      // })
      let idOptions = {
        app_Play_Id: new Date().getTime() + '' + Math.round(Math.random() * 999) + 1, // 播放ID（类型：String，长度16位，唯一）
        app_Id: 'IEP', // 应用ID（类型：String，也可叫做渠道ID如：wechat）
        user_Id: Math.round(Math.random() * 999) + 1, // this.userInfo.id, // 用户ID（类型：Number，调用方系统里的用户ID）
        video_Id: initPlayCon.fileId// 视频ID（类型：Number，调用方系统里的视频ID）
      }
      let userInfo = this.userInfo
      let videoTitle = this.curVideoPlayer.title
      let videoSize = 0
      let tencentid = initPlayCon.fileId
      let heartbeatsFreq = 1
      let acPlayerToolInit = window.acPlayerToolInit(`player`, {
        fileID: initPlayCon.fileId,
        appID: initPlayCon.appId, // 腾讯的appID
        psign: initPlayCon.psign,
        licenseUrl: 'https://1307224350.trtcube-license.cn/license/v2/1307224350_1/v_cube.license',
        fakeFullscreen: true,
        plugins: {
          ProgressMarker: true
        }
      }, idOptions, userInfo, videoTitle, videoSize, tencentid, heartbeatsFreq)
      this.acPlayerToolInit = acPlayerToolInit
      let player = acPlayerToolInit.player
      // player.fakeFullscreen = true
      player.poster(this.curVideoPlayer.poster)
      // 默认当前播放的player内容
      this.player = player
      this.handleGetBarrage()
      // 获取视频dom
      let videoDom = document.getElementById(`player`)
      // // 获取视频下面转圈圈的dom
      // let tcpLoadingSpinnerDom = videoDom.getElementsByClassName('tcp-loading-spinner')[0]
      // tcpLoadingSpinnerDom.style.display = 'none'
      // 初始化播放按钮的dom
      let vjsBigPlayButtonDom = videoDom.getElementsByClassName('vjs-big-play-button')[0]
      vjsBigPlayButtonDom.style.display = 'none'
      player.on('loadstart', () => {
        // 记录一个空格，在空格李米娜假如快进快退
        let vjsPBTDIV = document.getElementsByClassName('vjs-custom-control-spacer')[0]
        if (vjsPBTDIV.className.indexOf('vjs-custom-control-fast') < 0) {
          vjsPBTDIV.classList.add('vjs-custom-control-fast')
          // 将 SVG 字符串转换为 DOM 节点
          let iconBackElement = document.createElement('div')
          iconBackElement.innerHTML = iconBack
          let iconForwardElement = document.createElement('div')
          iconForwardElement.innerHTML = iconForward
          // 获取第一个子元素，即 SVG 元素
          iconForwardElement = iconForwardElement.firstChild
          iconBackElement = iconBackElement.firstChild
          iconBackElement.addEventListener('click', () => {
            this.backward15Seconds()
          })
          iconForwardElement.addEventListener('click', () => {
            this.forward15Seconds()
          })
          // 插入到第一个位置
          vjsPBTDIV.insertBefore(iconForwardElement, vjsPBTDIV.firstChild)
          vjsPBTDIV.insertBefore(iconBackElement, vjsPBTDIV.firstChild)
        }

        // 设置当前视频从第几秒开始,作用于播放记录
        const videoHistory = window.localStorage.getItem('videoHistory')
        let lastPlayTime = videoHistory ? JSON.parse(videoHistory)[this.curVideoPlayer.id] : 0
        player.currentTime(lastPlayTime)
        // 设置当前视频播放速度
        if (localStorage.getItem('playbackRate')) {
          player.playbackRate(localStorage.getItem('playbackRate'))
        } else {
          player.playbackRate(1)
        }
      })

      player.on('play', () => {
        if (!this.hasIdBool) {
          this.curVideoPlayer.duration = 1 // 页面停留时长，向上取整
          handleTraceVideo(this.curVideoPlayer)
        }
        this.hasIdBool = true
        // 开始播放，改变状态
        this.curVideoPlayer.learningStatus = `${this.curVideoPlayer.learningStatus}` === '1' ? '1' : '2'
        sessionStorage.setItem('curPlayVideoStatus', this.curVideoPlayer.learningStatus)
        // 默认开始播放的时候提交状态为2
        // hadnleUpdateVideo(this.curVideoPlayer)
      })

      // 播放器暂停时触发
      player.on('pause', () => {
        this.handleStashVideoTime(this.curVideoPlayer)
      })

      // 监听视频倍速切换时记录下倍速
      player.on('ratechange', (e) => {
        if (!localStorage.getItem('curPlayVideoId') || localStorage.getItem('curPlayVideoId') === this.curVideoPlayer.id) {
          let playbackRate = player.playbackRate()
          localStorage.setItem('playbackRate', playbackRate)
          localStorage.setItem('curPlayVideoId', this.curVideoPlayer.id)
        } else {
          localStorage.setItem('curPlayVideoId', this.curVideoPlayer.id)
        }
      })

      // 当前时间变化调用的一次性函数
      player.on('timeupdate', (e) => {
        // 获取当前时间
        let curTime = player.currentTime()
        // 获取当前时间，记录当前播放时间
        this.currentTime = curTime
        // 记录当前视频总长度
        this.curVideoDuration = player.duration()
        // 是否显示横屏进度条
        const isMobile = /iPhone|Android/i.test(navigator.userAgent)
        const deviceWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
        let verticalProDom = document.getElementsByClassName('vertical-progress')[0]
        let videoBtmCon = document.querySelector('.video-js').className + ''
        if ((isMobile && deviceWidth < 768) && player.isFullscreen() && (videoBtmCon.indexOf('vjs-paused') > -1 || videoBtmCon.indexOf('vjs-user-active') > -1)) {
          verticalProDom.style.display = 'block'
        } else {
          verticalProDom.style.display = 'none'
        }
        // 横屏进度条控制
        this.slider = this.currentTime / this.curVideoDuration * 100
        // 弹幕的显示与隐藏
        let barrageScreenDom = document.getElementById('vjs-barrage-screen')
        if (barrageScreenDom && barrageScreenDom.style) {
          let visibility = barrageScreenDom.style.visibility
          if (visibility === 'hidden') {
            this.isDanmu = false
          } else {
            this.isDanmu = true
          }
        }
        // 判断最后4秒提示跳到下一个视频，如果还有下一个视频
        if (this.curVideoDuration - curTime <= 10) {
          let curIndex = 0
          this.videoList.map((item, index) => {
            if (item.id === this.curVideoPlayer.id) {
              curIndex = index
            }
          })
          if (curIndex + 1 < this.videoList.length) {
            let curVideo = this.videoList[curIndex + 1]
            this.nextVideoTitle = curVideo.title
            this.boolNextTip = true
          }
        } else {
          this.boolNextTip = false
        }
        this.playDurationArr.push(curTime)
        if (this.playDurationArr.length > 1) {
          this.handleStaticDuration()
          this.$emit('timeupdate', {
            currentTime: curTime,
            playDuration: this.playDuration,
            currentVideo: this.curVideoPlayer
          })
        }
        if (curTime >= player.duration()) {
          this.handleVideoTrace(this.curVideoPlayer)
          this.playerNext()
        }
        if (this.playDurationTrace > 5) {
          this.curVideoPlayer.duration = Math.round(this.playDurationTrace) // 页面停留时长，向上取整
          this.playDurationTrace = 0
          this.handleStaticDuration()
          handleTraceVideo(this.curVideoPlayer)
        }
      })

      // 切换视频的全屏
      player.on('fullscreenchange', (e) => {
        let playerDom = document.getElementById('player')
        let verticalProDom = document.getElementsByClassName('vertical-progress')[0]
        const vjsPlaybackRate = document.getElementsByClassName('vjs-playback-rate')[0]
        const vjsKnowledgePoints = document.getElementsByClassName('vjs-knowledge-points')[0]
        // 判读是否是手机
        const isMobile = /iPhone|Android/i.test(navigator.userAgent)
        const deviceWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
        if (isMobile && deviceWidth < 768) {
          this.isRotateFullScreen = player.isFullscreen()
          let progressControlDom = document.getElementsByClassName('vjs-progress-control')[0]
          // 视频里面是否显示弹幕的icon
          let danmuDomBtn = document.getElementsByClassName('vjs-barrage-switcher')[0]
          if (player.isFullscreen()) {
            playerDom.classList.add('player-isfullscreen')
            if (this.curVideoPlayer.dotList && this.curVideoPlayer.dotList.length) {
              vjsPlaybackRate.before(vjsKnowledgePoints)
              vjsKnowledgePoints.style.display = 'flex'
            }
            progressControlDom.style.display = 'none'
            verticalProDom.style.display = 'block'
            danmuDomBtn.style.display = 'block'
            stopScroll()
          } else {
            this.isShowKnowledgePoints = false
            playerDom.classList.remove('player-isfullscreen')
            vjsKnowledgePoints.style.display = 'none'
            progressControlDom.style.display = 'flex'
            verticalProDom.style.display = 'none'
            danmuDomBtn.style.display = 'none'
            canScroll()
          }
        } else {
          if (player.isFullscreen()) {
            stopScroll()
          } else {
            canScroll()
          }
        }
      })
    },

    // 改变播放视频内容
    handleChangeVideo(changeVideo, oldVal) {
      this.handleVideoTrace(oldVal)
      this.curVideoPlayer = changeVideo
      this.player.loadVideoByID({
        fileID: changeVideo.videoMaterial.fileId, // 请传入需要播放的视频 fileID（必须）
        appID: changeVideo.videoMaterial.appId, // 请传入点播账号的 appID（必须）
        // 私有加密播放需填写 psign， psign 即播放器签名，签名介绍和生成方式参见链接：https://cloud.tencent.com/document/product/266/42436
        psign: changeVideo.videoMaterial.psign,
      })
      this.handleGetBarrage()
      this.player.poster(changeVideo.poster)
      this.player.on('loadstart', () => {
        this.player.play()
      })
    },

    // 播放下一个视频
    playerNext() {
      let curIndex = 0
      this.videoList.map((item, index) => {
        if (item.id === this.curVideoPlayer.id) {
          curIndex = index
        }
      })
      if (curIndex + 1 === this.videoList.length) return
      this.curVideoPlayer = this.videoList[curIndex + 1]
      this.$parent.$parent.currentVideo = this.curVideoPlayer
      // setTimeout(() => {
      //   let nextVideo = this.curVideoPlayer.videoMaterial
      //   this.$parent.$parent.currentVideo = this.curVideoPlayer
      //   this.player.loadVideoByID({
      //     fileID: nextVideo.fileId, // 请传入需要播放的视频 fileID（必须）
      //     appID: nextVideo.appId, // 请传入点播账号的 appID（必须）
      //     // 私有加密播放需填写 psign， psign 即播放器签名，签名介绍和生成方式参见链接：https://cloud.tencent.com/document/product/266/42436
      //     psign: nextVideo.psign,
      //     autoplay: true
      //     // licenseUrl: 'https://license-url',
      //   })
      //   this.player.poster(this.curVideoPlayer.poster)
      //   // this.player.on('loadstart', () => {
      //   //   this.player.play()
      //   // })
      // })
    },

    // 缓存历史记录
    handleStashVideoTime(videoData) {
      if (!videoData) return
      if (window && window.localStorage && this.currentTime > 0) {
        let videoHistory = window.localStorage.getItem('videoHistory')
        if (this.curVideoDuration <= this.currentTime) {
          this.currentTime = 0
        }
        if (videoHistory) {
          videoHistory = Object.assign(JSON.parse(videoHistory), {[videoData.id]: this.currentTime})
        } else {
          videoHistory = {[videoData.id]: this.currentTime}
        }
        window.localStorage.setItem('videoHistory', JSON.stringify(videoHistory))
      }
    },

    // 视频播放时长统计
    handleStaticDuration() {
      if (this.playDurationArr.length > 1) {
        this.playDurationArr[0] = (this.playDurationArr[1] - this.playDurationArr[0] > 1 || this.playDurationArr[0] > this.playDurationArr[1]) ? this.playDurationArr[1] : this.playDurationArr[0]
        this.playDuration = this.playDuration + Number(this.playDurationArr[this.playDurationArr.length - 1]) - Number(this.playDurationArr[0])
        this.playDurationTrace = this.playDurationTrace + Number(this.playDurationArr[this.playDurationArr.length - 1]) - Number(this.playDurationArr[0])
        this.playDurationArr = [this.playDurationArr[this.playDurationArr.length - 1]]
      }
    },

    // 埋点方法
    handleVideoTrace(curplayer) {
      if (curplayer) {
        this.precurVideoPlayer = curplayer
      }
      // 监听销毁时的动作
      this.handleStashVideoTime(this.precurVideoPlayer)
      this.handleStaticDuration()
      if (this.playDuration >= 1) {
        this.endTime = new Date() // 埋点观看结束时间
        this.precurVideoPlayer.duration = Math.round(this.playDurationTrace) // 页面停留时长，向上取整
        handleTraceVideo(this.precurVideoPlayer)
        // 上报当前视频播放时长
        // const params = {
        //   videoId: this.precurVideoPlayer.id,
        //   iepUserId: this.userInfo.id,
        //   playDuration: Math.round(this.playDuration),
        //   courseId: this.$route.query.courseId
        // }
        // if (sessionStorage.getItem('traningCampId')) {
        //   params['campId'] = sessionStorage.getItem('traningCampId')
        // }
        // traceVideoDuration(params).then(() => { })
        // this.playDuration = 0
      }
      this.currentTime = 0
    },

    // 页面关闭或者刷新的时候特意用fetch同步请求
    handleVideoTraceSync(curplayer) {
      if (curplayer) {
        this.precurVideoPlayer = curplayer
      }
      const token = Vue.ls.get(ACCESS_TOKEN)
      const baseURL = process.env.baseURL
      // 监听销毁时的动作
      this.handleStashVideoTime(this.precurVideoPlayer)
      this.handleStaticDuration()
      if (this.playDuration > 0) {
        this.endTime = new Date() // 埋点观看结束时间
        this.precurVideoPlayer.duration = Math.round(this.playDurationTrace) // 页面停留时长，向上取整
        // handleTraceVideo(this.precurVideoPlayer)
        this.precurVideoPlayer = Object.assign(this.precurVideoPlayer, {
          token,
          baseURL
        })
        handleTraceVideoAsync(this.precurVideoPlayer)
        // 上报当前视频播放时长
        // const params = {
        //   videoId: this.precurVideoPlayer.id,
        //   iepUserId: this.userInfo.id,
        //   playDuration: Math.round(this.playDuration),
        //   courseId: this.$route.query.courseId
        // }
        // if (sessionStorage.getItem('traningCampId')) {
        //   params['campId'] = sessionStorage.getItem('traningCampId')
        // }
        // fetch(`${baseURL}/api/course/completed/records/addPlayDuration/${params.videoId}`, {
        //   method: 'POST',
        //   body: JSON.stringify(params),
        //   headers: {
        //     'Content-Type': 'application/json',
        //     'Authorization': `Bearer ${token}`,
        //     'userId': this.userInfo.id
        //   },
        //   keepalive: true
        // })
        // this.playDuration = 0
      }
      this.currentTime = 0
    },
  }
}

</script>
<style lang="less" scoped>
.video-js {
  /deep/ .vjs-control-bar {
    .vjs-play-control, .vjs-volume-panel, .vjs-mute-control, .vjs-volume-control, .vjs-current-time, .vjs-duration, .vjs-playback-rate, .vjs-fullscreen-control {
      width: 3em;
    }
  }

  /deep/ .vjs-pdt-time {
    display: none;
  }

  /deep/ .vjs-custom-control-spacer {
    flex: 1;
  }

  /deep/ .vjs-control-bar {
    display: flex;
    align-items: center;
  }

  /deep/ .vjs-volume-panel.vjs-volume-panel-vertical {
    width: 3em;
  }

  /deep/ .vjs-barrage-switcher {
    display: none;
  }

  /deep/ .vjs-mute-control {
    padding: 0;
  }

  /deep/ .vjs-volume-panel .vjs-volume-control.vjs-volume-vertical {
    left: -3em;
    margin-left: 0;
  }

  /deep/ .tcp-video-quality-switcher {
    display: none;
  }

  /deep/ .vjs-custom-control-fast {
    display: flex !important;
    align-items: center;
    width: 80px !important;
  }
  /deep/ .icon_fast {
    min-width: 18px;
    min-height: 18px;
    max-width: 18px;
    max-height: 18px;
    margin-right: 10px;
  }
}
</style>
<style lang="less" scoped>
.player {
  #player {
    width: 100%;
    height: 200px;
    left: 0;

    &.player-isfullscreen2 {
      left: 0;
    }

    &.player-isfullscreen {
      position: absolute !important;
      top: 0 !important;
      left: 100% !important;
      bottom: 0 !important;
      right: 0 !important;
      height: 100vw !important;
      width: 100vh !important;
      -webkit-transform-origin: top left !important;
      -ms-transform-origin: top left !important;
      transform-origin: top left !important;
      -webkit-transform: rotate(90deg) !important;
      -ms-transform: rotate(90deg) !important;
      transform: rotate(90deg) !important;
    }
  }

  .video-block {
    display: block;
    width: 100%;
    height: 200px;
    object-fit: cover;
    position: relative;

    .icon-play {
      position: absolute;
      width: 40px;
      display: block;
      left: 50%;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);
    }
  }

  .tips {
    position: absolute;
    max-width: 100%;
    box-sizing: border-box;
    font-size: 12px;
    z-index: 999;
    bottom: 50px;
    padding: 10px;
    background-color: rgba(0, 0, 0, .3);
    color: #fff;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    &.fullScreen {
      -webkit-transform-origin: top left;
      -ms-transform-origin: top left;
      transform-origin: top left;
      -webkit-transform: rotate(90deg);
      -ms-transform: rotate(90deg);
      transform: rotate(90deg);
      max-width: 100vh;
      height: 36px;
      bottom: 0;
      top: 0;
      left: 86px;
    }
  }

  .vjs-knowledge-points {
    display: none;
    color: #fff;
    font-weight: bold;
    align-items: center;

    &.isFull {
      display: flex;
    }
  }

  .knowledge-points-list {
    position: fixed;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    background: rgba(0,0,0,.8);
    border-radius: 20px;
    padding: 0 15px 10px;
    width: 205px;
    height: calc(100vw - 60px);
    left: 98vw;
    top: calc(100vh - 240px);
    box-sizing: border-box;
    -webkit-transform-origin: top left !important;
    -ms-transform-origin: top left !important;
    transform-origin: top left !important;
    -webkit-transform: rotate(90deg) !important;
    -ms-transform: rotate(90deg) !important;
    transform: rotate(90deg) !important;

    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 40px;

      .title {
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        font-size: 14px;
        color: #fff;
      }

      .header-right {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #fff;

        i {
          font-style: normal;
          color: #EB1700;
        }
      }
    }

    .cont {
      flex: 1;
      height: 0;
      padding: 0;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;

      .dot-list-fullscreen {
        flex: 1;
        height: 0;
        overflow-y: auto;
        padding-right: 16px;
        margin-right: -16px;
        position: relative;

        .dot-item-fullscreen {
          cursor: pointer;
          position: relative;
          margin-bottom: 10px;

          .dot-item-cont {
            display: flex;
            align-items: flex-start;

            .dot-icon {
              margin-right: 10px;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-top: 6px;

              img {
                width: 6px;
              }
            }

            .dot-title {
              display: flex;
              flex: 1;
              align-items: flex-start;

              .time {
                font-family: PingFang HK, PingFang HK;
                font-weight: 400;
                font-size: 12px;
                color: #FFF;
              }

              .name {
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 14px;
                color: #FFF;
                flex: 1;
              }
            }
          }

          &:last-child {
            height: auto;
            margin-bottom: 0;

            .dot-line {
              display: none;
            }
          }

          .dot-line {
            position: absolute;
            top: 14px;
            left: 2px;
            width: 2px;
            height: 100%;
            border-radius: 10px;
            background: url("~@/assets/images/course/dot-line.png") no-repeat center center / 100% 100%;
          }

          &.cur {
            .dot-item-cont {
              .dot-title {
                .time {
                  color: #EB1700;
                }

                .name {
                  color: #EB1700;
                }
              }
            }
          }
        }
      }
      .course-summary {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #5F5F5F;

        span {
          font-weight: 500;
          color: #2B2B2B;
        }
      }
    }
  }

  .vertical-progress {
    position: absolute;
    left: 42px;
    height: calc(100vh - 20px);
    margin: 10px 0;
    z-index: 9999;
    top: 0;
    display: none;

    &.isFull {
      display: block;
    }
  }
}

.input-danmu {
  width: 110px;
  height: 24px;
  overflow: hidden;
  display: flex;
  align-items: center;
  z-index: -1;
  background-color: #F7F7F9;
  border-radius: 80px;
  border: 1px solid #E4E4E4;
  position: absolute;
  top: 260px;
  left: 65%;

  .danmu-txt {
    width: 70%;
    display: block;
    font-size: 12px;
    color: #333;
    font-weight: 400;
    outline: none;
    border: none;
    padding-left: 9px;
    box-sizing: border-box;
    line-height: 24px;
    background-color: transparent;

    &::placeholder {
      color: #959698;
    }
  }

  .danmu-icon {
    width: 14px;
    padding-left: calc(15% - 7px);
    border-left: 1px solid #898989;
    height: 15px;
  }
}

.dialog-div {
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 99;
  top: 0;
  left: 0;

  .dialog-bg {
    background-color: rgba(0, 0, 0, .5);
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 9;
    top: 0;
    left: 0;
  }

  .wrapper {
    position: absolute;
    z-index: 9;
    bottom: 0;
    width: 100vw;
    height: calc(100vh - 200px);
    background-color: #fff;
    border-radius: 10px 10px 0 0;
    box-sizing: border-box;
    padding: 17px 14px;
    overflow: auto;

    .div-confirm-txt {
      display: flex;
      align-items: center;
      margin-bottom: 24px;

      .txt {
        flex: 1;
        height: 35px;
        background-color: #F2F3F7;
        border-radius: 8px;
        line-height: 35px;
        padding-left: 17px;
        box-sizing: border-box;
        font-size: 13px;
        color: #6A7481;
        margin-right: 10px;
        outline: none;
        border: none;
      }

      .send-btn {
        border-radius: 8px;
        width: 80px;
        height: 35px;
        text-align: center;
        line-height: 35px;
        color: #fff;
        font-size: 13px;
        background-color: #EB1700;
      }
    }

    .danmu-div {
      .danmu-title {
        font-size: 15px;
        color: rgba(0, 0, 0, 0.9);
        line-height: 22px;
        font-weight: 600;
        margin-bottom: 13px;
      }

      .danmu-list {
        display: flex;
        flex-wrap: wrap;

        .danmu-item {
          border-radius: 8px;
          margin-right: 7px;
          margin-bottom: 8px;
          text-align: center;
          padding: 8px 12px;
          box-sizing: border-box;
          background-color: #F2F3F7;
          font-size: 13px;
          color: #6A7481;
          line-height: 20px;

          &.cur {
            color: #fff;
            background-color: #EB1700;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/course/components/VideoPlayer.vue